module.exports = "/static/video/philippines.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/philippines.mp4
// module id = 392
// module chunks = 0